<digires-user-guides-table *ngIf="allUserGuidesData$"
                           [title]="title"
                           [addButtonTitle]="addButtonLabel"
                           [fileReferenceType]="fileRefType"
                           [inputTableData]="allUserGuidesData$ | async"
></digires-user-guides-table>
